import React, { memo } from "react";
import { useStore } from "src/store";
import AdUnitBody from "./AdUnitBody";

const AdUnit = memo(props => {
  const { rtkPlaceHolder } = props;
  const store = useStore("config");
  const { headerbiddingprovider = "", clientid, variant, brand, repclientid, multiClientDomain } = store("config");

  return headerbiddingprovider == "RTKio" && rtkPlaceHolder ? (
    <div dangerouslySetInnerHTML={{ __html: rtkPlaceHolder }} />
  ) : (
    <AdUnitBody
      {...props}
      clientid={clientid}
      variant={variant}
      brand={brand}
      repclientid={repclientid}
      multiClientDomain={multiClientDomain}
      setIndexExchangeTargeting={headerbiddingprovider === "IndexExchange"}
    />
  );
});

export default AdUnit;
